import React, { Component } from 'react';
import classNames from 'classnames';

import {
  IWithSettingsProps,
  withSettings,
} from '../../../../components/context/settings';

import { normalizeImageUrl } from '../../../../lib/utils/image/index';
import compose from '../../../../lib/utils/compose';

import { ImgCover, ImgCoverStyle } from '../../../../components/ui/img/index';

import { IWithI18nProps, withI18n } from '../../../../components/context/i18n';
import { IWithTPAProps, withTPA } from '../../../../components/context/tpa';

import SubscribeLinks, {
  SubscribeLinksPlacement,
} from '../../../../components/ui/SubscribeLinks';

import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';

import getStyles from './EpisodePageHeader.styles';
import styles from './EpisodePageHeader.scss';
import EpisodePageNavIndex from '../Nav/EpisodePageNavIndex';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

interface IEpisodePageHeaderProps
  extends IWithSettingsProps,
    IWithTPAProps,
    IWithI18nProps {
  episode: IPodcastEpisode;
}

class EpisodePageHeader extends Component<IEpisodePageHeaderProps> {
  render() {
    const { episode, settings, tpa } = this.props;
    const { deviceType } = tpa.params;
    const { buttonStyle } = settings.common;

    const dynamicStyle = getStyles({
      colors: settings.colors.episode,
      fonts: settings.fonts.episode,
      deviceType,
      buttonStyle,
    });

    return (
      <section
        className={classNames(styles.headerWrapper, dynamicStyle.headerWrapper)}
        aria-label={episode.title}
      >
        <div data-hook="episode.header" className={styles.headerContainer}>
          <EpisodePageNavIndex
            className={styles.backButtonLayout}
            episode={episode}
          />
          <div
            className={classNames(styles.imageContainer, {
              [styles.imageShadow]: settings.episode.dropImageShadow,
            })}
          >
            <ImgCover
              data-hook="episode.header.image"
              coverStyle={ImgCoverStyle.SQUARE}
              src={normalizeImageUrl(episode.image || episode.podcast.image)}
              title={episode.title}
            />
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.headings}>
              {deviceType === TPADeviceType.MOBILE && (
                <SubscribeLinks
                  placement={SubscribeLinksPlacement.EpisodeHeader}
                />
              )}
              <h1
                data-hook="episode.header.title"
                className={classNames(
                  styles.episodeTitle,
                  dynamicStyle.episodeTitle,
                )}
              >
                {episode.title}
              </h1>
              <h2
                data-hook="episode.header.podcast-title"
                className={classNames(
                  styles.podcastTitle,
                  dynamicStyle.podcastTitle,
                )}
              >
                {episode.podcast.title}
              </h2>
              {deviceType === TPADeviceType.DESKTOP && (
                <SubscribeLinks
                  placement={SubscribeLinksPlacement.EpisodeHeader}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default compose(withSettings, withTPA, withI18n)(EpisodePageHeader);
